import { FormatTypeCopySink } from './format-type.copysink';
import { DelimitedTextDataset } from 'shell-models-lib';
import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';


@Metamodel.model({
    name: 'DelimitedTextSink',
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(DelimitedTextDataset) }
})
export class DelimitedTextSink extends FormatTypeCopySink {
    public static readonly MODEL: IModel;
    public static readonly QUOTE_ALL: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'QUOTE_ALL',
        display: stringResources.ModelName_QuoteAll
    })
    public quoteAll?: boolean;
}
